import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, FloatingLabel, Form, Modal, Row, Table } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumb from '../../components/Breadcrumb';
import { DEBOUNCE_DELAY } from '../../util/constant';
import { get, patch, post } from '../../services/apiController';
import moment from 'moment';
import PaginationInPage from '../Pagination';
import Select from '../../components/atoms/Select';
import { GrDocumentExcel } from 'react-icons/gr';
import useDebounce from '../useDebounce';
import { getStoredData, get_auth_key } from '../../util';
import { Link } from 'react-router-dom';
import { FiSave } from 'react-icons/fi';
import { DeleteIcon, EditIcon, UploadIcon } from '../icons';
import FileIcon from '../../components/atoms/FileIcon';
import DeleteModal from '../../components/common/DeleteModal';
import AddEditNamkeenOrderForm from './order-screens/AddEditNamkeenOrderForm';

const NamkeenOrder = ({ viewType }) => {
  const TABLE_DEFAULT_LIMIT = 50;
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [orderList, setOrderList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [namkeens, setNamkeens] = useState([]);
  const [uploadModel, setUploadModel] = useState(false);
  const [deleteModel, setDeleteModel] = useState(false);
  const [idToUpdated, setIdToUpdated] = useState('');
  const [order, setOrder] = useState({});
  const [orderEditModal, setOrderEditModal] = useState(false);

  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const admins = ['admin', 'super-admin', 'cake-admin'].includes(storedData.role);

  // Set default 30-days date range for all view types
  const getDefaultDateRange = () => {
    const threeMonthsAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');
    const today = moment().format('YYYY-MM-DD');
    return {
      locationId: '',
      namkeenId: '',
      dateFrom: threeMonthsAgo,
      dateTo: today,
    };
  };

  const [filters, setFilters] = useState(getDefaultDateRange());

  const handleFilterChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleInputChange = (e, index, field) => {
    const { value } = e.target;

    // Update the specific item in the orderList using index
    const updatedOrderList = orderList.map((item, i) => (i === index ? { ...item, [field]: value } : item));

    // Update state with the new order list
    setOrderList(updatedOrderList);
  };

  const clickToDownload = useRef(null);

  function fetchOrders(conditions) {
    try {
      let url = `/cake/festival-namkeens/orders?locationId=${filters.locationId}&dateFrom=${filters.dateFrom}&dateTo=${filters.dateTo}&namkeenId=${filters.namkeenId}&viewType=${viewType}`;
      if (conditions === 'excel') {
        url += `&conditionType=download`;
      } else {
        url += `&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`;
      }
      get(url).then((response) => {
        if (conditions === 'excel') {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setOrderList(response.data.rows);
          setTotalRecords(response.data.count ?? 0);
        }
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  let formData = new FormData();
  const handleFileChange = (e) => {
    e.preventDefault();
    formData.append('dcInvoice', e.target.files[0]);
  };

  const uploadInvoice = (e, id) => {
    e.preventDefault();
    setIdToUpdated(id);
    setUploadModel(true);
  };

  const deleteInvoice = (e, id) => {
    e.preventDefault();
    setIdToUpdated(id);
    setDeleteModel(true);
  };

  const handleEdit = (orderId, index) => {
    const order = orderList[index];
    setIdToUpdated(orderId);
    setOrder(order);
    setOrderEditModal(true);
  };

  const handleUpload = async (e, orderId) => {
    e.preventDefault();
    try {
      post(formData, `/cake/festival-namkeens/orders/${orderId}?type=invoice`, false)
        .then((res) => {
          toast.success(res?.data?.message);
          setUploadModel(false);
          setIdToUpdated('');
          fetchOrders();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.data?.message);
        });
    } catch (err) {
      toast.error(err?.message || 'Something Went Wrong');
    }
  };

  const handleSave = (orderId, index) => {
    post(
      {
        dcDate: orderList[index]?.dcDate,
        dcNumber: orderList[index]?.dcNumber,
        dcRemark: orderList[index]?.dcRemark,
        trip: orderList[index]?.trip,
      },
      `/cake/festival-namkeens/orders/${orderId}?type=dcDetail`
    )
      .then((res) => {
        toast.success(res.data.message);
        fetchOrders();
      })
      .catch((err) => toast.error(err?.response?.data?.data?.message) || 'Something went wrong');
  };

  const handleStatusUpdate = (orderId) => {
    patch({}, `/cake/festival-namkeens/orders/${orderId}`)
      .then((res) => {
        toast.success(res.data.message);
        fetchOrders();
        // const orderIndex = orderList.findIndex((order) => order.id === orderId);
        // if (orderIndex !== -1) {
        //   const updatedOrders = [...orderList]; // Create a shallow copy of the orderList array
        //   const currentStatus = updatedOrders[orderIndex].status;

        //   // Update the status in the copy
        //   updatedOrders[orderIndex].status = currentStatus === 'Accepted' ? 'Rejected' : 'Accepted';

        //   // Update state with the new order list
        //   setOrderList(updatedOrders);
        // }
      })
      .catch((err) => {
        const errorMessage = err?.response?.data?.message || 'Something went wrong';
        toast.error(errorMessage);
      });
  };

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        fetchOrders();
      }
    },
    [viewType, filters],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    fetchOrders();
  }, [currentPage]);

  useEffect(() => {
    get(`/branches`)
      .then((response) => {
        setLocationList(response?.data?.rows);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data?.message || err.message);
      });
  }, []);

  useEffect(() => {
    get(`/cake/festival-namkeens/namkeen-list`)
      .then((response) => {
        setNamkeens(response.data);
      })
      .catch((err) => console.log('Err', err));
  }, []);

  return (
    <>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '/cake/home', title: 'Home' },
          { link: '#', title: viewType === 'dcDetails' ? 'Dispatch Report' : 'Namkeen Orders' },
        ]}
      />
      <div>
        <Link to={'/cake/home'} className="text-decoration-none">
          <button className="btn app-btn-primary mb-3 me-5">&larr; Back</button>
        </Link>
        <Link to={`/cake/${viewType === 'dcDetails' ? 'namkeen-orders' : 'namkeen-dc-details'}`} className="text-decoration-none">
          <button className="btn app-btn-primary mb-3 me-5" style={{ float: 'right' }}>
            {viewType === 'dcDetails' ? 'Namkeen Orders' : 'Dispatch Report'}
          </button>
        </Link>
      </div>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            {viewType === 'dcDetails' ? 'Dispatch Report' : viewType === 'rejectedOrderDetails' ? 'Rejected Orders' : 'Accepted Orders'} |{' '}
            {totalRecords}
          </h4>
          <Row>
            {admins && (
              <Col xs={3}>
                <FloatingLabel controlId="floatingSelect" label="Location" className="mb-3">
                  <Form.Select className="input" value={filters.locationId} name="locationId" onChange={handleFilterChange}>
                    <option value="">Select All</option>
                    {locationList?.map((item) => {
                      return (
                        <option key={item?.id} value={item?.id}>
                          {`${item?.name} (${item?.number})`}
                        </option>
                      );
                    })}
                  </Form.Select>
                </FloatingLabel>
              </Col>
            )}
            <Col xs={admins ? 3 : 4}>
              <FloatingLabel controlId="floatingSelect" label="Namkeen" className="mb-3">
                <Select
                  value={filters.namkeenId}
                  name="namkeenId"
                  label="All"
                  onChange={handleFilterChange}
                  data={namkeens}
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      minHeight: '55px',
                    }),
                  }}
                />
              </FloatingLabel>
            </Col>
            <Col xs={admins ? 2 : 3}>
              <FloatingLabel controlId="floatingInput" label="Delivery Date From">
                <Form.Control name="dateFrom" onChange={handleFilterChange} value={filters.dateFrom} type="date" />
              </FloatingLabel>
            </Col>
            <Col xs={admins ? 2 : 3}>
              <FloatingLabel controlId="floatingInput" label="Delivery Date To">
                <Form.Control name="dateTo" onChange={handleFilterChange} value={filters.dateTo} type="date" />
              </FloatingLabel>
            </Col>
            <Col style={{ alignContent: 'center' }} xs={2}>
              <GrDocumentExcel
                title="Download excel"
                style={{ cursor: 'pointer', width: '30px', height: '30px' }}
                className="react-icons green"
                onClick={() => fetchOrders('excel')}
              />
              <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
                HiddenClick
              </a>
            </Col>
          </Row>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>Ordered Date</th>
                    <th>Delivery Date</th>
                    <th>Shop Location</th>
                    <th>Trip Number</th>
                    <th>Client</th>
                    <th>Namkeen</th>
                    <th>Quantity (In grams)</th>
                    <th>Number (In pieces)</th>
                    <th>Remarks</th>
                    <th>Dispatch Date</th>
                    <th>DC Number</th>
                    <th>DC Upload</th>
                    <th>DC Remark</th>
                    <th>Trip</th>
                    {admins && <th>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {orderList?.map((item, index) => (
                    <tr key={item?.id}>
                      <td>{moment(item?.createdAt).format('DD/MM/YYYY hh:mm A')}</td>
                      <td>{moment(item?.date).format('DD/MM/YYYY')}</td>
                      <td>{item?.Branch?.number}</td>
                      <td>{item?.tripNumber}</td>
                      <td>{item?.clientName}</td>
                      <td>{item?.FestivalNamkeen?.name}</td>
                      <td>{item?.quantity}</td>
                      <td>{item?.number}</td>
                      <td>{item?.remarks}</td>
                      {viewType === 'dcDetails' ? (
                        <>
                          <td>{item.dcDate ? moment(item.dcDate).format('DD/MM/YYYY') : ''}</td>
                          <td>{item.dcNumber}</td>
                          <td>
                            {!item?.dcInvoice ? (
                              <a href="/" onClick={(e) => uploadInvoice(e, item?.id)}>
                                <UploadIcon style={{ color: 'green' }} />
                              </a>
                            ) : (
                              <>
                                <a
                                  href={
                                    item?.syncedOnBucket
                                      ? `${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${item?.dcInvoice}`
                                      : `${process.env.REACT_APP_BASE_URL}/${item?.dcInvoice}`
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <FileIcon
                                    fileUrl={
                                      item?.syncedOnBucket
                                        ? `${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${item?.dcInvoice}`
                                        : `${process.env.REACT_APP_BASE_URL}/${item?.dcInvoice}`
                                    }
                                  />
                                </a>
                                <span onClick={(e) => deleteInvoice(e, item?.id)}>
                                  <DeleteIcon style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }} />
                                </span>
                              </>
                            )}
                          </td>
                          <td>{item.dcRemark}</td>
                          <td>{item?.trip}</td>{' '}
                          <td>
                            <EditIcon
                              title="Updated Order Details"
                              onClick={() => handleEdit(item?.id, index)}
                              style={{ marginRight: '8px', cursor: 'pointer' }}
                            />
                          </td>
                        </>
                      ) : (
                        <>
                          {admins ? (
                            <>
                              <td>
                                <input
                                  value={item.dcDate ?? ''}
                                  name="dcDate"
                                  onChange={(e) => handleInputChange(e, index, 'dcDate')}
                                  type="date"
                                />
                              </td>
                              <td>
                                <input
                                  value={item.dcNumber ?? ''}
                                  name="dcNumber"
                                  onChange={(e) => handleInputChange(e, index, 'dcNumber')}
                                  type="text"
                                  placeholder="DC Number"
                                />
                              </td>
                              <td>
                                {!item?.dcInvoice ? (
                                  <a href="/" onClick={(e) => uploadInvoice(e, item?.id)}>
                                    <UploadIcon style={{ color: 'green' }} />
                                  </a>
                                ) : (
                                  <>
                                    <a
                                      href={
                                        item?.syncedOnBucket
                                          ? `${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${item?.dcInvoice}`
                                          : `${process.env.REACT_APP_BASE_URL}/${item?.dcInvoice}`
                                      }
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <FileIcon
                                        fileUrl={
                                          item?.syncedOnBucket
                                            ? `${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${item?.dcInvoice}`
                                            : `${process.env.REACT_APP_BASE_URL}/${item?.dcInvoice}`
                                        }
                                      />
                                    </a>
                                    <span onClick={(e) => deleteInvoice(e, item?.id)}>
                                      <DeleteIcon style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }} />
                                    </span>
                                  </>
                                )}
                              </td>
                              <td>
                                <input
                                  value={item.dcRemark ?? ''}
                                  name="dcRemark"
                                  onChange={(e) => handleInputChange(e, index, 'dcRemark')}
                                  type="text"
                                  placeholder="DC Remark"
                                />
                              </td>
                              <td>
                                <input
                                  value={item.trip ?? ''}
                                  name="trip"
                                  onChange={(e) => handleInputChange(e, index, 'trip')}
                                  type="text"
                                  placeholder="Trip"
                                  style={{ width: '45px' }}
                                />
                              </td>
                            </>
                          ) : (
                            <>
                              <td>{item.dcDate ? moment(item.dcDate).format('DD/MM/YYYY') : ''}</td>
                              <td>{item.dcNumber}</td>
                              <td>
                                {item?.dcInvoice && (
                                  <>
                                    <a
                                      href={
                                        item?.syncedOnBucket
                                          ? `${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${item?.dcInvoice}`
                                          : `${process.env.REACT_APP_BASE_URL}/${item?.dcInvoice}`
                                      }
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <FileIcon
                                        fileUrl={
                                          item?.syncedOnBucket
                                            ? `${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${item?.dcInvoice}`
                                            : `${process.env.REACT_APP_BASE_URL}/${item?.dcInvoice}`
                                        }
                                      />
                                    </a>
                                    <span onClick={(e) => deleteInvoice(e, item?.id)}>
                                      <DeleteIcon style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }} />
                                    </span>
                                  </>
                                )}
                              </td>
                              <td>{item.dcRemark}</td>
                              <td>{item?.trip}</td>
                            </>
                          )}
                          {admins && (
                            <td className="d-flex justify-content-center align-items-center">
                              <EditIcon
                                title="Updated Order Details"
                                onClick={() => handleEdit(item?.id, index)}
                                style={{ marginRight: '8px', cursor: 'pointer' }}
                              />
                              <FiSave
                                title="Save dispatch details"
                                className="me-2 text-success"
                                onClick={() => handleSave(item?.id, index)}
                                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                              />
                              <Button
                                className={`btn ${item?.status === 'Accepted' ? 'btn-secondary' : 'btn-info'} btn-sm`}
                                title="Update Order Status"
                                onClick={() => handleStatusUpdate(item?.id)}
                              >
                                {item?.status === 'Accepted' ? 'Reject' : 'Accept'}
                              </Button>
                            </td>
                          )}
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      {uploadModel && (
        <Modal size="sm" show={uploadModel} backdrop="static" keyboard={false} className="request-modal">
          <Modal.Header>
            <Modal.Title>Upload Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control onChange={handleFileChange} name="dcInvoice" type="file" />
          </Modal.Body>
          <Modal.Footer>
            <div className="btn-wrapper">
              <button
                onClick={() => {
                  setIdToUpdated('');
                  setUploadModel(false);
                }}
                className="btn app-btn-default btn-sm"
              >
                Cancel
              </button>
              <button onClick={(e) => handleUpload(e, idToUpdated)} className="btn app-btn-primary btn-sm">
                Upload
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      {deleteModel && (
        <DeleteModal
          title="Delete DC Invoice"
          description="Are you sure want to delete this delivery challan invoice? This actions can't be undone."
          open={deleteModel}
          onClose={() => {
            setIdToUpdated('');
            setDeleteModel(false);
          }}
          url={`/cake/festival-namkeens/orders/dc/${idToUpdated}`}
          callback={fetchOrders}
        />
      )}
      {orderEditModal && (
        <Modal size="lg" show={orderEditModal} backdrop="static" keyboard={false} className="request-modal">
          <Modal.Header>
            <Modal.Title>Update Namkeen Order</Modal.Title>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setIdToUpdated(null);
                setOrderEditModal(false);
              }}
            ></button>
          </Modal.Header>
          <Modal.Body style={{ fontFamily: 'auto' }}>
            <AddEditNamkeenOrderForm
              orderId={idToUpdated}
              namekeenOrderData={order}
              callback={() => {
                setIdToUpdated(null);
                setOrderEditModal(false);
                fetchOrders();
              }}
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default NamkeenOrder;
